<template>
    <div v-if="actAs" class="act-as-banner text-bg-danger">
        <span>{{ $t('actAs.banner', { user: userName, actor: actAs.actor.name }) }}</span>
        <span v-if="minutesLeft !== null" class="ms-2 small">{{ $t('actAs.remaining', { min: minutesLeft }) }}</span>
        <button type="button" class="btn btn-sm btn-light ms-2" :disabled="stopping" @click="stop">{{ $t('actAs.stop') }}</button>
    </div>
</template>

<script>
import { actAs } from '@/composables/useActAs';
import { performLogout } from '@/utils/logout';

export default {
    name: 'ActAsBanner',
    data() {
        return {
            nowTs: Date.now(),
            interval: null,
            stopping: false,
        };
    },
    computed: {
        actAs() {
            return actAs.value;
        },
        userName() {
            // Re-read when the act-as state changes, i.e. on a new login.
            if (!this.actAs) return '';
            try { return JSON.parse(localStorage.getItem('user') || '{}').name || ''; }
            catch { return ''; }
        },
        expiresTs() {
            const ts = this.actAs?.expiresAt ? Date.parse(this.actAs.expiresAt) : NaN;
            return Number.isNaN(ts) ? null : ts;
        },
        minutesLeft() {
            if (this.expiresTs === null) return null;
            return Math.max(0, Math.ceil((this.expiresTs - this.nowTs) / 60000));
        },
    },
    watch: {
        minutesLeft(min) {
            // The server rejects everything past expiry anyway; leave cleanly instead.
            if (min === 0) this.stop();
        },
    },
    methods: {
        tick() {
            this.nowTs = Date.now();
        },
        onVisibilityChange() {
            if (document.visibilityState === 'visible') this.tick();
        },
        async stop() {
            if (this.stopping) return;
            this.stopping = true;
            try {
                await performLogout(this.$router);
            } finally {
                this.stopping = false;
            }
        },
    },
    mounted() {
        this.interval = setInterval(this.tick, 30000);
        document.addEventListener('visibilitychange', this.onVisibilityChange);
    },
    beforeUnmount() {
        clearInterval(this.interval);
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
    },
};
</script>

<style>
.act-as-banner {
  position: sticky;
  top: 0;
  z-index: 1030;
  padding: 6px 10px;
  text-align: center;
}
</style>
